import slide from "../assets/slide/1.jpg";

export const carouselData = [
  {
    img: slide,
    alt: "Test",
  },
  {
    img: slide,
    alt: "Test",
  },
  {
    img: slide,
    alt: "Test",
  },
];
